import { Loader } from '@googlemaps/js-api-loader';

// eslint-disable-next-line no-undef
const location = single_map.location;
// eslint-disable-next-line no-undef
const ajaxUrl = single_map.ajax_url;
// eslint-disable-next-line no-undef
const nonce = single_map.nonce;

let map, google, iconUrl;

function initMap() {
	const mapContainer = document.querySelector('#map_canvas');
	const mapZoom = +mapContainer.dataset.zoom;
	iconUrl = mapContainer.dataset.markerIcon;

	fetch(`${ajaxUrl}?action=google_api_key&nonce=${nonce}`)
		.then((response) => response.json())
		.then((data) => {
			const loader = new Loader({
				apiKey: data.google_api_key,
			});

			loader.load().then((googleReponse) => {
				google = googleReponse;
				const mapSettings = {
					zoom: mapZoom,
					center: new google.maps.LatLng(location.lat, location.lng),
				};

				map = new google.maps.Map(mapContainer, mapSettings);

				initMarker();
			});
		})
		.catch((e) => {
			// eslint-disable-next-line no-console
			console.log(e);
		});
}

function initMarker() {
	const icon = {
		url: iconUrl,
		scaledSize: new google.maps.Size(40, 40), // scaled size
	};

	new google.maps.Marker({
		position: { lat: location.lat, lng: location.lng },
		icon: iconUrl ? icon : null,
		map,
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initMap();
});
